import * as React from 'react';

const SvgSuccessCircleOutline = (props) => (React.createElement("svg", Object.assign({ width: 24, height: 24, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
    React.createElement("path", { d: "m8.21 11.32 2.29 2.3 5.29-5.3 1.42 1.42-6.71 6.7-3.71-3.7 1.42-1.42Z", fill: "currentColor" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 12C2 6.48 6.48 2 12 2s10 4.48 10 10-4.48 10-10 10S2 17.52 2 12Zm2 0c0 4.41 3.59 8 8 8s8-3.59 8-8-3.59-8-8-8-8 3.59-8 8Z", fill: "currentColor" })));

export { SvgSuccessCircleOutline as default };
